import { getHassNodeSchema } from '../../Hasp/properties/v2/hass/index.js';
import { describeHassNode } from '../../hass/hassPresentation.js';
import { HASS_NODE_SIZE } from '../../hass/hassLayout.js';

export const HASS_COLORS = Object.freeze({
    body: '#1e293b',
    text: '#f8fafc',
    summary: '#cbd5e1',
    port: '#0f172a',
    portStroke: '#e2e8f0',
    objectPort: '#38bdf8',
    // Wires by what they carry: an entity, a bound value, an object's events, a run.
    entityWire: '#38bdf8',
    valueWire: '#a78bfa',
    objectWire: '#f59e0b',
    wire: '#94a3b8',
    selected: '#facc15',
    valid: '#22c55e',
    error: '#ef4444',
    warning: '#f59e0b',
});

/** Colour of a wire from the output it starts at (see the hass port vocabulary). */
function wireColor(wire) {
    if (wire.from.object !== undefined) return HASS_COLORS.objectWire;
    if (wire.from.port === 'state' || wire.from.port === 'target') return HASS_COLORS.entityWire;
    if (wire.from.port === 'value') return HASS_COLORS.valueWire;
    return HASS_COLORS.wire;
}

/** How the Home Assistant flow graph is drawn (see buildGraphScene). */
export const hassRenderDomain = Object.freeze({
    namePrefix: 'hass',
    getNodeSchema: getHassNodeSchema,
    nodeSize: HASS_NODE_SIZE,
    describeNode: describeHassNode,
    colors: HASS_COLORS,
    wireColor,
});
